import { AccountChangeLanguageModel } from '@/domain/models/account/account-change-language'

export interface AccountChangeLanguage {
  change(request: AccountChangeLanguage.RequestModel): Promise<void>
}

export namespace AccountChangeLanguage {
  export const Key = 'account-change-language'
  export type RequestModel = AccountChangeLanguageModel
}
